/* Localize Xtra's generated cart controls after initial and AJAX rendering. */
(() => {
  function init() {
    const config = document.getElementById('bm-cart-ui-strings');
    if (!config) return;
    const words = JSON.parse(config.textContent);
    function label(el, text, content = false) {
      if (el.getAttribute('aria-label') !== text) el.setAttribute('aria-label', text);
      el.setAttribute('translate', 'no');
      el.classList.add('notranslate');
      if (content && el.textContent !== text) el.textContent = text;
    }
    function update() {
      document.querySelectorAll('.form-cart, #cart').forEach(root => {
        root.querySelectorAll('.input-amount .incr').forEach(el => label(el, words.increase));
        root.querySelectorAll('.input-amount .decr').forEach(el => label(el, words.decrease));
        root.querySelectorAll('.input-show .toggle').forEach(el => label(el, words.toggle, true));
      });
      if (document.querySelector('.form-cart, .cart-empty')) {
        document.querySelectorAll('#content .swiper-button-next').forEach(el => label(el, words.next));
        document.querySelectorAll('#content .swiper-button-prev').forEach(el => label(el, words.previous));
      }
      // Localize only the app's existing trigger text; preserve its dropdown and events.
      const names = {English:'en',German:'de',Dutch:'nl',French:'fr',Italian:'it',Romanian:'ro',Czech:'cs',Polish:'pl'};
      const currencies = {'Swiss Franc':'CHF',Euro:'EUR','Czech Koruna':'CZK','Polish Zloty':'PLN'};
      const display = typeof Intl.DisplayNames === 'function' ? new Intl.DisplayNames([document.documentElement.lang || 'en'], {type:'language'}) : null;
      document.querySelectorAll(':is(.bm-transtore-header,.bm-transtore-footer) .ts-switcher-btn__language .ts-switcher-btn__name').forEach(el => {
        const code = names[el.textContent.trim()];
        if (code && display) {
          const text = display.of(code);
          if (el.textContent !== text) el.textContent = text;
          el.classList.add('notranslate'); el.setAttribute('translate', 'no');
        }
      });
      document.querySelectorAll(':is(.bm-transtore-header,.bm-transtore-footer) .ts-switcher-btn__currency .ts-switcher-btn__name').forEach(el => {
        const currency = currencies[el.textContent.trim()];
        if (currency) {el.textContent = currency; el.classList.add('notranslate'); el.setAttribute('translate','no');}
      });
    }
    let pending = false;
    const observer = new MutationObserver(() => {
      if (pending) return;
      pending = true;
      queueMicrotask(() => {pending = false; update();});
    });
    observer.observe(document.body, {subtree: true, childList: true});
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
